module.exports = __webpack_public_path__ + "static/quartier_M-046dc7b4aca213daeb0c364920992c7d.png";